import classNames from 'classnames'
import PropTypes from 'prop-types'

import './Wave.scss'

export const Wave = ({ imageLeft = false }) => {
  // const fillColour = theme
  //   ? sauceColours[`cc-light-green`] ||
  //     sauceColours[`green-rpi-green-tint-75`] // for old sauce theme colours
  //   : colour

  return (
    <div className="wave-wrapper">
      <svg
        className={classNames('wave', { 'wave--left': imageLeft })}
        title="Wavy line"
        width="317"
        height="40"
        viewBox="0 0 317 40"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M317 40V12.9152C303.348 23.6162 160.137 28.9956 117.836 12.9153C75.4901 -3.18254 42.6779 -5.39222 0 12.9152V40H317Z"
          fill="#BAEDC2"
        />
      </svg>
    </div>
  )
}

Wave.propTypes = {
  imageLeft: PropTypes.bool,
  theme: PropTypes.string,
  colour: PropTypes.string,
}

export default Wave
